<template>
  <div class="unlocks" v-infinite-scroll="getUnlocks" infinite-scroll-disabled="busy" infinite-scroll-distance="150" infinite-scroll-root>
    <CustomizeHeader :home="false" :goBack="true" title="解鎖主播"></CustomizeHeader>
    <v-row class="py-1 ma-0">
      <v-col
        class="d-flex justify-center align-center" 
        style="padding: 6px"
        cols="4" 
        sm="2" 
        md="2" 
        lg="1" 
        xl="1" 
        v-for="unlock in unlocks"
      >
        <div class="seller" @click="$router.push(`/seller/${unlock[0].seller.id}`)">
        <v-avatar size="100%" min-height="100">
          <v-img aspect-ratio="1" :src="$HOST_URL + unlock[0].seller.usericon"/>
        </v-avatar>
        <div class="text-ellipsis text-center mt-1" :title="unlock[0].seller.nickname">{{ unlock[0].seller.nickname }}</div>
      </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CustomizeHeader from '@/components/CustomizeHeader'
export default {
  components: { CustomizeHeader },
  data() {
    return {
      page: 1,
      busy: false,
      unlocks: [],
    }
  },
  methods: {
    getUnlocks() {
      this.busy = true
      this.axios(`/member/online/purchase?page=${this.page}&size=50`).then(response => {
        this.unlocks = this.unlocks.concat(Object.values(response.data.data))
        if(this.page != response.data.last_page) {
          this.page += 1
          this.busy = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.unlocks {
  .seller {
    @extend .pointer;
    padding: 4px;
    overflow: auto;
    font-size: 14px;
    width: 100%;
    &:hover {
      transform: scale(1.015);
    }
  }
}
</style>